'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Avatar = _interopDefault(require('@material-ui/core/Avatar'));

var getInitialsFromName = function (name) {
    if (!name || typeof name !== 'string') {
        return '';
    }
    var words = name
        .toUpperCase()
        .replace(/[^A-Z\s]+/g, '') // Remove none alpha characters or whitespace
        .split(' ') // Split name into array or words
        .filter(Boolean); // Remove empty elements
    if (words.length === 0) {
        return '';
    }
    if (words.length === 1) {
        return words[0].substring(0, 2);
    }
    return "" + words[0][0] + words[1][0];
};
var getAvatar = function (src, name, classes) {
    return src ? (React__default.createElement(Avatar, { "data-testid": 'avatarfromsrc', alt: name, src: src })) : (React__default.createElement(Avatar, { "data-testid": 'avatar-from-name', variant: 'rounded', className: classes.rounded }, getInitialsFromName(name)));
};

exports.getAvatar = getAvatar;
exports.getInitialsFromName = getInitialsFromName;
